const state = {
    navs: [],
    storeList: [],
    closeStoreList: [],
    currentSortKey: {},
    hasMore: true,
    page: 0,
    scrollTop: 0
}

const mutations = {
    setStoreList (state, value) {
        state.storeList = value
    },
    setCloseStoreList (state, value) {
        state.closeStoreList = value
    },
    setCurrentSortKey (state, value) {
        state.currentSortKey = value
    },
    setHasMore(state, value) {
        state.hasMore = value
    },
    setPage(state, value) {
        state.page = value
    },
    setScrollTop(state, value) {
        state.scrollTop = value
    },
    setNavs(state, value) {
        state.navs = value
    },
    resetCommonStoreList(state, value) {
        state.storeList = []
        state.closeStoreList = []
        state.currentSortKey = {}
        state.hasMore = true
        state.page = 0
        state.scrollTop = 0
        state.navs = []
    }
}


export default {
	state,
	mutations
}
